import React from 'react';

//Componentes
import TableContainer from '../../components/table/TableContainer';

//Estilos
import './DJCVList.css';

function DJCVList({ functions, states }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        newDJCV,
    } = functions;

    const { DJCVListData, tableData, viniedos, settings, EnableBtn } = states;

    return (
        <div className="DJCVList-container">
            {DJCVListData.length > 0 ? (
                <>
                    <TableContainer tableData={tableData} />
                </>
            ) : (
                <h3>No tiene ninguna Declaración de Cancelación de Viñedo</h3>
            )}
            {new Date(settings?.djcp_rango_inicio) <
                new Date() <
                new Date(settings?.djcp_rango_fin) && (
                <div className="DJCVList-footer">
                    <form onSubmit={handleSubmit(newDJCV)}>
                        <select {...register('myViniedo')}>
                            <option value={0}>Elegir Viñedo</option>
                            {viniedos?.map((v) => {
                                return (
                                    <option key={v.id} value={v.id}>
                                        {v.num}
                                    </option>
                                );
                            })}
                        </select>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={EnableBtn === 0}
                        >
                            Nueva DJCV
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
}

export default DJCVList;
